__turbopack_context__.v({
  "graphs": "aeCm9G_graphs",
  "pricelists": "aeCm9G_pricelists",
});
